import { features } from '@/mocks/mangaData';

export default function Features() {
  return (
    <section id="features" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <div className="flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
          <i className="ri-sparkling-line text-sm" />
          核心功能
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          追更、缓存、订阅，一站搞定
        </h2>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
          围绕"追更不怕漏"打造的一整套能力，从提醒到离线阅读，让你把每一部想追的作品都稳稳握在手里。
        </p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((f, i) => (
          <article
            key={f.id}
            className={`group rounded-2xl p-6 transition-colors ${
              i % 3 === 1 ? 'bg-background-100' : 'bg-background-50 ring-1 ring-background-200'
            }`}
          >
            <span
              className={`flex h-12 w-12 items-center justify-center rounded-2xl transition-transform group-hover:scale-105 ${
                i % 3 === 0
                  ? 'bg-primary-500 text-background-50'
                  : i % 3 === 1
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-secondary-500 text-background-50'
              }`}
            >
              <i className={`${f.icon} text-xl`} />
            </span>
            <h3 className="mt-5 text-base font-bold text-foreground-950">{f.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}